import { FormattedMessage } from "react-intl";
import styles from "../ConfigureAI/configureAIBehaviour.module.scss";
import classNames from "classnames";
import { Info1, Info2 } from "pages/ChatPage/pages/newChat/icons/PrivateChatIcons";

export const Notifications = ({ notificationIds, headingId, incompatible, subHeading, values, isPrivate }: { notificationIds: string[]; headingId?: string; incompatible?: boolean; subHeading?: string, values?: Record<string, any>; isPrivate?:boolean;}) => {
    const getIconForId = (id: string) => {
        if (id === "private.chat.info1") {
          return <Info1/>;
        }
        if (id === "private.chat.info2") {
          return <Info2/>;
        }
        return null;
      };
    return (
        <div className={classNames(styles.tipsContainer, {
            [styles.incompatible]: incompatible,
            [styles.isPrivate]:isPrivate,
        })}>
            {headingId && (
            <div className={classNames(styles.tipsHeading, {
                [styles.incompatible]: incompatible,
            })}>
                <FormattedMessage id={headingId} values={values} />
            </div>
            )}

            {subHeading && (
                <div className={styles.subHeading}>
                    <FormattedMessage id={subHeading} />
                </div>
            )}

            <div className={classNames("font-inter", styles.tipsList, {
                [styles.incompatible]: incompatible,
                [styles.bulletList]: headingId === "workspace.context.notificationhead",
                [styles.isPrivate]:isPrivate,
            })}>
                {notificationIds.map((id, index) => (
                    <div key={index} className={`${incompatible ? styles.incompatibletipItem : isPrivate? styles.isPrivate : styles.tipItem}`}>
                       {!isPrivate && (<span className={styles.tipNumber}>{index + 1}.</span> )} {" "}
                        {/* <FormattedMessage id={id} /> */}
                        <span className="flex-shrink-0">{getIconForId(id)}</span>
                        <FormattedMessage
                            id={id}
                            values={{
                                b: (chunks: React.ReactNode) => (
                                    <span className={styles.tipLink}>{chunks}</span>
                                ),
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};